
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 2c.368 0 .667.298.667.667v2.666A.667.667 0 0110 6H8.667v1.333h2.666c.368 0 .667.299.667.667v2h1.333c.368 0 .667.299.667.667v2.666a.667.667 0 01-.667.667h-4a.667.667 0 01-.666-.667v-2.666c0-.368.298-.667.666-.667h1.334V8.667H5.333V10h1.334c.368 0 .666.299.666.667v2.666a.667.667 0 01-.666.667h-4A.667.667 0 012 13.333v-2.666c0-.368.298-.667.667-.667H4V8c0-.368.298-.667.667-.667h2.666V6H6a.667.667 0 01-.667-.667V2.667C5.333 2.298 5.632 2 6 2h4zm-4 9.333H3.333v1.334H6v-1.334zm6.667 0H10v1.334h2.667v-1.334zm-3.334-8H6.667v1.334h2.666V3.333z","fill":"#910000"}})])
          )
        }
      }
    